import { Component, input } from '@angular/core';
import { Plans } from '../../constants/plan.constants';

@Component({
  selector: 'app-plan-type',
  standalone: false,
  templateUrl: './plan-type.component.html',
  styleUrl: './plan-type.component.scss',
})
export class PlanTypeComponent {
  plan = input<string>('');
  height = input<number>(17);
  classes = input<string>('align-text-top px-1');

  plans = Plans;
}
